import React, { FC } from 'react';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import { Layout } from "./Layout";
import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4 } from './Step4';
import { Step5 } from './Step5';
import { Step6 } from './Step6';

export const Roof: FC = () => {
  const { roofStore } = useStoreon<IState, IEvents>('roofStore');

  const determineCurrentStep = () => {
    switch (roofStore.stepID) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      case 5:
        return <Step5 />;
      case 6:
        return <Step6 />;
    }
  };

  return <Layout>{determineCurrentStep()}</Layout>;
};
